<template>
    <div id="add-meal-plan">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn :color="primaryColor" dark small v-bind="attrs" v-on="on" @click.stop="openAddMealPlanDialog()">
                    <v-icon>mdi-basket-plus</v-icon>
                </v-btn>
            </template>
            <span>Add Meal Plan</span>
        </v-tooltip>
        <v-dialog v-model="addMealPlanDialog" max-width="576" persistent>
            <v-card>
                <v-card-title>
                    Add Meal Plan
                </v-card-title>
                <v-card-text>
                    <v-form ref="addMealPlanForm" v-model="valid" lazy-validation>
                        <v-text-field v-model="currentMealPlan.mealPlan" clearable label="Meal Plan"
                            :rules="mealPlanRules" required>
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="addBtn" class="white--text" :color="successColor" :disabled="!valid"
                        @click="openAddMealPlanConfirmationDialog()">
                        Add
                    </v-btn>
                    <v-btn ref="closeBtn" :color="warningColor" @click="closeAddMealPlanDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addMealPlanConfirmationDialog" max-width="540">
            <v-card ref="addMealPlanConfirmationCard">
                <v-card-title>Confirmation</v-card-title>
                <v-card-text>
                    Are you sure you would like to add <b>{{ currentMealPlan.mealPlan }}</b> as a Meal Plan? Please
                    click
                    confirm to proceed.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="confirmBtn" :color="dangerColor" text @click="addMealPlan()">
                        Confirm
                    </v-btn>
                    <v-btn :color="warningColor" text @click="closeAddMealPlanConfirmationDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'meal-plan-add',
    data() {
        return {
            addMealPlanDialog: false,
            addMealPlanConfirmationDialog: false,
            currentMealPlan: {
                mealPlan: ''
            },
            mealPlanRules: [
                v => !!v || 'Meal plan is required',
                v => (v && v.length >= 2) || 'Meal plan must be more than 2 characters',
            ],
            valid: true
        }
    },
    methods: {
        addMealPlan() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?updateEntity`;

            // Parse array into string
            formData.append('data', JSON.stringify(this.currentMealPlan));
            formData.append('mode', 'updateEntity');
            formData.append('type', 'MealPlans');

            // Loading icon
            this.$refs.confirmBtn.loading = true;

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `${that.currentMealPlan.mealPlan} has been successfully added as a Meal Plan.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `${that.currentMealPlan.mealPlan} could not be added as a Meal Plan. Please contact your system administrator.`, true);
                    }

                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.closeAddMealPlanConfirmationDialog();
                    that.closeAddMealPlanDialog();
                })
                .catch(function () {
                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        closeAddMealPlanConfirmationDialog() {
            this.addMealPlanConfirmationDialog = false;
        },
        closeAddMealPlanDialog() {
            this.addMealPlanDialog = false;
        },
        openAddMealPlanConfirmationDialog() {
            // Validate form before confirmation
            if (this.$refs.addMealPlanForm.validate()) {
                this.addMealPlanConfirmationDialog = true;
            }
        },
        openAddMealPlanDialog() {
            // Reset form
            this.resetForm();
            this.addMealPlanDialog = true;
        },
        resetForm() {
            // Reset form validation
            this.resetFormValidation();

            // Reset current meal plan
            this.currentMealPlan.mealPlan = '';
        },
        resetFormValidation() {
            if (this.$refs.addMealPlanForm) {
                this.$refs.addMealPlanForm.resetValidation();
            }
        },
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>